import { useEffect } from 'react'
import type { RefObject } from 'react'
import type { MapCanvasHandle } from './MapCanvas'
import { focusCardProps, focusZoom, type VesselFocus } from './vesselFocus'

/**
 * Перелёт карты к судну, выбранному в строке поиска, и его карточка.
 *
 * Общий хук для «Карт» и «Аналитики»: строка живёт в сайдбаре (одна на оба
 * раздела), карта — в разделе, поэтому выбор идёт через ViewContext.
 *
 * Карточка открывается СРАЗУ, не дожидаясь конца полёта: она привязана к
 * координатам судна и переезжает вместе с картой (см. MapCallout). Пока место
 * карточки задавалось пикселями, ждать `moveend` было обязательно — до конца
 * полёта проекция ещё старая, и карточка встала бы мимо судна.
 */
export function useVesselFocus(
  mapRef: RefObject<MapCanvasHandle | null>,
  focus: VesselFocus | null,
  showCard: (card: { lng: number; lat: number; props: Record<string, unknown> }) => void,
) {
  useEffect(() => {
    if (!focus) return
    const map = mapRef.current?.getMap()
    if (!map) return
    showCard({ lng: focus.lon, lat: focus.lat, props: focusCardProps(focus, Date.now()) })
    map.flyTo({ center: [focus.lon, focus.lat], zoom: focusZoom(map.getZoom()) })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focus])
}
